import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import "./snackbar.scss";
import { useDispatch } from "react-redux";
import { setErrorDisplay } from "../../state/actions/globalAction";
import React from "react";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SnackBar = ({ error, message, severity = "error", onClose }) => {
  const dispatch = useDispatch();

  const closeHandler = () => {
    if (error) {
      dispatch(setErrorDisplay(""));
    }
    if (onClose) {
      onClose();
    }
  };

  const displayMessage = error || message;
  const isOpen = !!displayMessage;

  // Determine actual severity. If it's an error string from redux, force 'error'
  const actualSeverity = error ? "error" : severity;

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={closeHandler}
      className={error ? "error-snackbar" : ""} // Keep legacy class if needed or remove
    >
      <Alert
        onClose={closeHandler}
        severity={actualSeverity}
        sx={{ width: "100%" }}
      >
        {displayMessage}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
